module.exports = __webpack_public_path__ + "img/x2_2025_04_25@2x.859f56e3.png";